import React/* , { useEffect } */ from 'react';
import { /* useDispatch, */ useSelector } from 'react-redux';
import RenderLegacyCusto from '../../RenderLegacyCusto';
/* import { actions as fusionActions } from '../../../reducers/fusion'; */
import './Channels.scss';

const Channels = ({ selectedProduct }) => {
  const { currentSubproducts, productState } = useSelector(state => state.fusion);
  /* const dispatch = useDispatch(); */

  /* useEffect(() => {
    const { product, recom } = selectedProduct;
    const { taxonomy } = product;
    const { promoCode, prodCode } = recom;
    dispatch(
      fusionActions.getSubproductsFromProductsBegins({
        recomCode: taxonomy || prodCode,
        promoCode,
      })
    );
  }, [dispatch, selectedProduct]); */

  if (!currentSubproducts) {
    return null;
  }

  return <RenderLegacyCusto currentSubproducts={currentSubproducts} />;
};

export default Channels;
